import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import search from "../../assets/search.png";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import { toast } from "react-toastify";
import Rating from "../common/Rating/Rating";
import HeaderImg from "../../assets/findAgent/headerImg.webp";
import { Info, Star } from "lucide-react";
import GoogleAddressAutocompleteInput from "../common/GoogleAddressAutocompleteInput/GoogleAddressAutocompleteInput";

const AgentReview = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const [star, setStar] = useState(0);

  const [AgentData, setAgentData] = useState({});
  const [ReviewData, setReviewData] = useState({
    // star: 5,
    review: "",
    type: "Selling",
    client_address: "",
    client_firstname: "",
    client_lastname: "",
    client_phoneNumber: "",
    client_email: "",
  });

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setReviewData({ ...ReviewData, [name]: value });
  };

  const setClientAddress = useCallback((address) => {
    setReviewData((prev) => ({ ...prev, client_address: address }));
  }, []);

  //console.log("🚀 ~ AgentReview ~ ReviewData:===============================================>", ReviewData)
  useEffect(() => {
    GetAgentData(id);
  }, []);

  const GetAgentData = async (id) => {
    await axiosInstanceAuth
      .post(`Agency_Agent/ViewProfile`, {
        id: id,
      })
      .then((res) => {
        const mydata = res?.data?.data;
        if (res?.data?.status) {
          setAgentData(mydata);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };

  const [textAreaLength, setTextAreaLength] = useState();

  const primaryColor = AgentData?.agency_id?.primary_color || "#2563EB";
  const bgLight = primaryColor.startsWith("#")
    ? `${primaryColor}15`
    : "#EFF6FF";
  const stepCircleStyle = { backgroundColor: "#097FE6" };

  const SubmitReqest = async () => {
    try {
      if (star === 0) {
        toast.error("Please give a Star");
      } else if (ReviewData?.review === "") {
        toast.error("Please enter a Review");
      } else if (ReviewData?.client_firstname === "") {
        toast.error("Please enter a First Name");
      } else if (ReviewData?.client_lastname === "") {
        toast.error("Please enter a Last Name");
      } else if (ReviewData?.client_phoneNumber === "") {
        toast.error("Please enter a Phone Number");
      } else if (!emailRegex?.test(ReviewData?.client_email)) {
        toast.error("Please enter a valid Email");
      } else {
        await axiosInstanceAuth
          .post(`agentReview/${id}`, {
            // agent_id: id,

            star: star,
            review: ReviewData?.review,
            type: ReviewData?.type,
            client_address: ReviewData?.client_address,
            client_firstname: ReviewData?.client_firstname,
            client_lastname: ReviewData?.client_lastname,
            client_phoneNumber: ReviewData?.client_phoneNumber,
            client_email: ReviewData?.client_email,
          })
          .then((res) => {
            //console.log("🚀 ~ .then ~ res:", res)
            if (res?.data?.status) {
              toast.success("Review Submited Successfuly");
              navigate(`/agent-profile/${id}`);
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => {
            //console.log("------>> Error", err);
          });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div
        className={`w-full grid place-items-center py-3 ${AgentData?.agency_id?.primary_color ? "" : "bg-[#FFE512]"
          }`}
        style={
          AgentData?.agency_id?.primary_color
            ? { backgroundColor: AgentData.agency_id.primary_color }
            : undefined
        }
      >
        <LazyLoadImage
          src={AgentData?.agency_id?.agencyLargeLogo || HeaderImg}
          alt="icon"
          srcSet={AgentData?.agency_id?.agencyLargeLogo || HeaderImg}
          loading="lazy"
          effect="blur"
          className="h-12"
        />
      </div>
      <div className="bg-[#F3F6F9]">
        <div className="container mx-auto px-3 lg:px-44 py-20 space-y-6">
          <div>
            <h1 className="md:text-4xl text-2xl font-bold text-[#000929] mb-2">
              Leave a rating review for Brad
            </h1>
            <p className="text-base text-[#000929] opacity-75">
              Tell us how was your experience with {AgentData?.first_name}{" "}
              {AgentData?.last_name}.
            </p>
          </div>
          <div className="bg-white rounded-2xl border-[1.5px] border-[#EAEAEA] shadow-sm p-4 md:p-11 flex flex-col sm:flex-row justify-center sm:justify-start sm:items-center gap-4">
            <LazyLoadImage
              src={AgentData?.profileImg}
              alt=""
              effect="blur"
              className="w-28 h-28 rounded-full border-[4px] border-[#F3F6F9] object-cover"
            />
            <div className="flex flex-col min-w-0 gap-1">
              <div className="text-2xl font-semibold text-[#000929]">
                {AgentData?.first_name} {AgentData?.last_name}
              </div>
              <div className="text-base text-[#000929] opacity-75">
                Sales | {AgentData?.agency_id?.principal_name}
              </div>
              <div className="flex items-center gap-1 mt-1 text-[#000929] text-base">
                <Star
                  size={20}
                  fill="#C2C823"
                  stroke="#C2C823"
                  className="shrink-0 -mt-1"
                />
                <span className="text-[#000929] ">
                  <span className="font-semibold">
                    {(AgentData?.Rating ?? 0)?.toFixed(1)}{" "}
                  </span>
                  <span className="opacity-75">
                    ({AgentData?.agentReview} reviews)
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl border-[1.5px] border-[#EAEAEA] shadow-sm p-4 md:p-11 flex flex-col gap-2">
            <div className="flex items-center gap-4">
              <div
                className="flex items-center justify-center w-10 h-10 rounded-full text-white text-base font-semibold shrink-0"
                style={stepCircleStyle}
              >
                1
              </div>

              <h3 className="text-lg font-semibold text-[#171717]">
                How would you rate {AgentData?.first_name}'s work overall?
              </h3>
            </div>
            <div className="flex-1 min-w-0">
              <Rating
                main_style="!justify-start mt-3"
                inner_style=" !w-12 !h-12 md:!w-18 md:!h-18"
                star={star}
                setstar={setStar}
              />
            </div>
          </div>

          <div className="bg-white rounded-2xl border-[1.5px] border-[#EAEAEA] shadow-sm p-4 md:p-11 flex flex-col gap-2">
            <div className="flex items-center gap-4">
              <div
                className="flex items-center justify-center w-10 h-10 rounded-full text-white text-base font-semibold shrink-0"
                style={stepCircleStyle}
              >
                2
              </div>
              <h3 className="text-lg font-semibold text-[#171717]">
                Your review of {AgentData?.first_name}'s work
              </h3>
            </div>
            <div className="flex-1 min-w-0">
              <div className="rounded-xl p-4 mt-4 text-sm border border-[#DBEAFE] bg-[#EFF6FF]">
                <p className="font-semibold mb-2">Some things to consider</p>
                <ul className="list-disc ml-4 space-y-1 opacity-95">
                  <li>Please don't mention your name or financial details.</li>
                  <li>Keep it clean or we won't publish it.</li>
                  <li>Please check for errors before you submit it!</li>
                </ul>
              </div>
              <label className="block mt-5 text-sm font-medium text-[#000929]">
                Enter your review <span className="text-red-500">*</span>
              </label>
              <textarea
                rows={5}
                name="review"
                value={ReviewData?.review}
                onChange={(e) => {
                  setTextAreaLength(e.target.value.length);
                  setReviewData({ ...ReviewData, review: e.target.value });
                }}
                placeholder="How was that, knowledge of the market, friendliness or resourcefully... anything else?"
                className="w-full border border-[#E5E7EB] rounded-xl p-4 mt-2 outline-none focus:ring-2 focus:ring-offset-0 text-[#000929] placeholder-[#9CA3AF]"
              />
              <div className="text-right text-xs text-[#6B7280] mt-1">
                {textAreaLength ?? 0} / 500
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl border-[1.5px] border-[#EAEAEA] shadow-sm p-4 md:p-11 flex flex-col gap-2">
            <div className="flex items-center gap-4">
              <div
                className="flex items-center justify-center w-10 h-10 rounded-full text-white text-base font-semibold shrink-0"
                style={stepCircleStyle}
              >
                3
              </div>
              <h3 className="text-lg font-semibold text-[#171717]">
                Your Property
              </h3>
            </div>
            <div className="flex-1 min-w-0">
              <p className="mt-4 text-sm font-medium text-[#000929]">
                What did {AgentData?.first_name} help you with?
              </p>
              <ToggleType
                ReviewData={ReviewData}
                setReviewData={setReviewData}
              />
              <label className="block mt-5 text-sm font-medium text-[#000929]">
                Property Address bought or sold in the last 12 months
              </label>
              <GoogleAddressAutocompleteInput
                value={ReviewData?.client_address}
                onChange={setClientAddress}
                placeholder="Search for a street address"
                wrapperClassName="mt-2"
                icon={
                  <img
                    src={search}
                    alt=""
                    className="w-4 h-4 shrink-0 text-[#9CA3AF]"
                  />
                }
              />
              <p className="text-xs text-[#6B7280] mt-2">
                We'll not publish this details.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl border-[1.5px] border-[#EAEAEA] shadow-sm p-4 md:p-11 flex flex-col gap-2">
            <div className="flex items-center gap-4">
              <div
                className="flex items-center justify-center w-10 h-10 rounded-full text-white text-base font-semibold shrink-0"
                style={stepCircleStyle}
              >
                4
              </div>
              <h3 className="text-lg font-semibold text-[#171717]">
                Your details
              </h3>
            </div>
            <div className="flex-1 min-w-0">
              <div className="grid sm:grid-cols-2 gap-4 mt-4">
                <div>
                  <label className="block text-sm font-medium text-[#000929] mb-1.5">
                    First name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="client_firstname"
                    value={ReviewData?.client_firstname}
                    onChange={onChangeInput}
                    placeholder="Enter first name"
                    className="w-full border border-[#E5E7EB] rounded-xl p-3 text-sm outline-none focus:ring-2 focus:ring-offset-0 text-[#000929] placeholder-[#9CA3AF]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#000929] mb-1.5">
                    Last name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="client_lastname"
                    value={ReviewData?.client_lastname}
                    onChange={onChangeInput}
                    placeholder="Enter last name"
                    className="w-full border border-[#E5E7EB] rounded-xl p-3 text-sm outline-none text-[#000929] placeholder-[#9CA3AF]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#000929] mb-1.5">
                    Mobile phone number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    inputMode="tel"
                    name="client_phoneNumber"
                    value={ReviewData?.client_phoneNumber}
                    onChange={onChangeInput}
                    placeholder="Enter mobile phone number"
                    className="w-full border border-[#E5E7EB] rounded-xl p-3 text-sm outline-none text-[#000929] placeholder-[#9CA3AF]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#000929] mb-1.5">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="client_email"
                    value={ReviewData?.client_email}
                    onChange={onChangeInput}
                    placeholder="Enter email address"
                    className="w-full border border-[#E5E7EB] rounded-xl p-3 text-sm outline-none text-[#000929] placeholder-[#9CA3AF]"
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2 bg-[#EFF6FF] p-4 rounded-2xl border border-[#DBEAFE] mt-8">
              <Info size={20} className="text-[#097FE6]" />
              <p className="text-sm text-[#000929]">
                Why do we collect this information?
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl border-[1.5px] border-[#EAEAEA] shadow-sm p-4 md:p-11 flex flex-col gap-6">
            <button
              type="button"
              onClick={SubmitReqest}
              className="w-full py-4 rounded-full font-semibold text-white shadow-sm hover:opacity-95 transition"
              style={stepCircleStyle}
            >
              Send Review
            </button>

            <p className="text-center text-sm text-[#6B7280]">
              Check our our{" "}
              <Link
                to="/terms-and-conditions"
                className="font-medium text-[#097FE6]"
                style={{ color: primaryColor }}
              >
                terms and conditions
              </Link>{" "}
              and consent information{" "}
              <Link
                to="/privacy-policy"
                className="font-medium text-[#097FE6]"
                style={{ color: primaryColor }}
              >
                privacy policy
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgentReview;

const ToggleType = ({ ReviewData, setReviewData }) => {
  return (
    <div className="mt-3 w-full grid grid-cols-2 gap-2">
      {/* Selling */}
      <button
        type="button"
        onClick={() => setReviewData({ ...ReviewData, type: "Selling" })}
        className={`flex-1 py-3 text-sm rounded-full transition-all duration-300
          ${ReviewData?.type === "Selling"
            ? "bg-[#097FE6] font-semibold text-white shadow-[0px_4px_6px_-4px_#BEDBFF,0px_10px_15px_-3px_#BEDBFF]"
            : "bg-[#F3F6F9] rounded-full px-3 py-2.5 text-sm outline-none text-[#000929] placeholder-[#9CA3AF]"
          }`}
      >
        Selling
      </button>

      {/* Buying */}
      <button
        type="button"
        onClick={() => setReviewData({ ...ReviewData, type: "Buying" })}
        className={`flex-1 py-3 text-sm rounded-full transition-all duration-300
          ${ReviewData?.type === "Buying"
            ? "bg-[#097FE6] font-semibold text-white shadow-[0px_4px_6px_-4px_#BEDBFF,0px_10px_15px_-3px_#BEDBFF]"
            : " bg-[#F3F6F9] rounded-full px-3 py-2.5 text-sm outline-none text-[#000929] placeholder-[#9CA3AF]"
          }`}
      >
        Buying
      </button>
    </div>
  );
};
